// src/components/NewVehicleKeyFeatures.tsx

import { Box, Typography, Grid, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Feature } from '../types/NewVehicleTypes';

interface NewVehicleKeyFeaturesProps {
  features: Feature[];
}

export default function NewVehicleKeyFeatures({ features }: NewVehicleKeyFeaturesProps) {
  // Grab only the first 9 features
  const topFeatures = features.slice(0, 9);

  if (topFeatures.length === 0) return null;

  return (
    <Box mb={4}>
      <Typography variant="h6" fontWeight={800} mb={2}>Key Features</Typography>
      
      <Grid container spacing={2} mb={3}>
        {topFeatures.map((f) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={f.featureId}>
            <Box display="flex" gap={1} alignItems="flex-start">
              <CheckCircleIcon sx={{ color: '#FFB800', fontSize: 20, mt: 0.2 }} />
              <Typography variant="body2" color="text.secondary" fontWeight={500}>
                {f.featureName}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box display="flex" gap={2} flexWrap="wrap">
        <Button 
          variant="outlined" 
          startIcon={<FileDownloadOutlinedIcon />} 
          sx={{ 
            color: '#000', 
            borderColor: '#FFB800', 
            fontWeight: 700,
            textTransform: 'none',
            borderRadius: 2,
            px: 3,
            '&:hover': { borderColor: '#e5a600', bgcolor: 'rgba(255, 184, 0, 0.04)' } 
          }}
        >
          Download Brochure
        </Button>
        <Button 
          variant="outlined" 
          endIcon={<ChevronRightIcon />} 
          sx={{ 
            color: '#000', 
            borderColor: '#FFB800', 
            fontWeight: 700,
            textTransform: 'none',
            borderRadius: 2,
            px: 3,
            '&:hover': { borderColor: '#e5a600', bgcolor: 'rgba(255, 184, 0, 0.04)' } 
          }}
        >
          View Full Specifications
        </Button>
      </Box>
    </Box>
  );
}